<template>
  <v-card width="250" class="list-card" elevation="0">
    <v-list two-lines class="py-0 list-item" :class="[item.id === idOnPath ? 'on-path' : '']">
      <v-list-item class="pl-0" @click="selectItem(item)">
        <v-list-item-action v-show="selectionMode" class="mx-0 list-tile-action">
          <v-checkbox
            v-model="item.picked"
            :indeterminate="item.indeterminate"
            :disabled="!item.selectable"
            color="primary"
            hide-details
            single-line
            @change="pickedItem(item)"
          />
        </v-list-item-action>
        <v-list-item-avatar v-show="!selectionMode">
          <mf-icon v-show="item.isLeaf" fill color="marca-0">draft</mf-icon>
          <mf-icon v-show="!item.isLeaf" fill color="marca-0">folder</mf-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            <v-tooltip top open-delay="1000">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ item.name | capitalize }}</span>
              </template>
              <span class="item-name">{{ item.name | capitalize }}</span>
            </v-tooltip>
          </v-list-item-title>
          <v-list-item-subtitle v-show="!item.isLeaf">{{
            $tc('produtos.arvoreProdutos.quantidadeItens', quantity(item), { quantidade: quantity(item) })
          }}</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action v-show="!item.isLeaf">
          <mf-icon>keyboard_arrow_right</mf-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import capitalize from 'lodash/capitalize'
export default {
  filters: {
    capitalize(value) {
      if (value)
        return value
          .split(' ')
          .map((word) => capitalize(word))
          .join(' ')
      return ''
    },
  },
  props: {
    item: Object,
    idOnPath: String,
    selectionMode: Boolean,
  },
  methods: {
    quantity(item) {
      if (!item.children) return 0
      return item.children.length
    },
    selectItem(item) {
      if (item.children) this.$emit('selected-item', item)
    },
    pickedItem(item) {
      this.$emit('picked-item', item)
    },
  },
}
</script>

<style lang="scss">
.list-card {
  border-radius: 0 !important;
  .on-path {
    background-color: rgba(0, 0, 0, 0.1);
  }
  .list-item {
    .v-list__tile {
      padding-left: 0;
    }
    .v-list__tile__avatar {
      min-width: 40px;
    }
    .v-list__tile__title {
      span {
        font-size: 12px;
      }
    }
    .v-list__tile__sub-title {
      font-size: 12px;
    }
    .v-list__tile__action {
      min-width: 24px;
    }
  }
}
.list-tile-action {
  padding-left: 8px;
}
</style>
